{
  "checkedInTitle": "Bạn đã check-in",
  "postCheckInInstructions": "Hướng dẫn sau check-in",
  "appointmentDetails": "Chi tiết cuộc hẹn",
  "notifyWarehouse": "Chúng tôi đã thông báo cho kho hàng rằng bạn đã đến để họ có thể kiểm tra tình trạng sẵn sàng",
  "waitForStaff": "Vui lòng chờ hướng dẫn thêm từ nhân viên kho hàng",
  "unplannedDescription": "Có vẻ như bạn không có cuộc hẹn. Vui lòng chờ hướng dẫn thêm từ nhân viên kho hàng.",
  "whatsappDelay": "Tin nhắn WhatsApp đầu tiên có thể mất tối đa một phút để đến.",
  "bookNextTitle": "Đặt lịch hẹn cho lần sau",
  "bookNextBody": "Đăng ký Opendock để bạn có thể đặt lịch hẹn vào lần tới khi đến cơ sở này",
  "helpFooter": "Nếu bạn cần trợ giúp hoặc thông tin bổ sung, vui lòng liên hệ nhân viên kho hàng",
  "finalize": "Hoàn tất ({seconds})"
}
